module.exports = __webpack_public_path__ + "img/step-1.fa452c2c.png";